import { BarChart, Card, MIN_MODAL_CONTENT_HEIGHT } from "components";
import { useMemo, useState } from "react";
import { ChartExport, useExportableChart } from "shared/components";
import { useBuyingGroupInsight } from "../useBuyingGroupInsight";

interface BuyingGroupContactsByPersonaProps {
  campaignId: number;
}

export function BuyingGroupContactsByPersona(
  props: BuyingGroupContactsByPersonaProps
) {
  const [isExpanded, setIsExpanded] = useState(false);
  const buyingGroupInsight = useBuyingGroupInsight(props.campaignId);
  const data = useMemo(
    () =>
      (buyingGroupInsight.data?.contacts_by_persona ?? [])
        .filter((item) => item.contacts_per_persona && item.persona_name)
        .map((item) => ({
          // TODO: as unknown will be fixed by ts 5.5
          value: item.contacts_per_persona as unknown as number,
          label: item.persona_name as unknown as string,
        })),
    [buyingGroupInsight.data?.contacts_by_persona]
  );

  const chart = useExportableChart({
    title: "Buying Group Contacts By Persona",
    campaignId: props.campaignId,
    chart: (
      <BarChart
        stretch
        data={data}
        orientation="vertical"
        valueAxisLabel="Contacts"
        labelAxisLabel="Target Persona"
        maxXAxisHeight={70}
        minHeight={isExpanded ? MIN_MODAL_CONTENT_HEIGHT : undefined}
      />
    ),
  });

  return (
    <Card
      isLoading={buyingGroupInsight.isFetching}
      onExpandedChange={setIsExpanded}
      title={chart.title}
      hasData={!buyingGroupInsight.isFetching && data?.length > 0}
      isExpandable
      actions={
        <ChartExport
          size="small"
          campaignId={1}
          title={chart.title}
          onExportPNG={chart.downloadAsPng}
          data={data ?? []}
        />
      }
    >
      {chart.component}
      {chart.exportComponent}
    </Card>
  );
}
